import { Avatar, CardHeader, Grid, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import AppButton from "../../shares/AppButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import DomaineCompetenceForm from "./forms/DomaineCompetenceForm";
import { CVService } from "../../../../service/CVService";
import { useQuery } from "../../../../hooks/useQuery";
import { showFullName } from "../../../../Helpers/utilsHelper";
import { NA } from "../../../../utils/utilities";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import BusinessIcon from "@mui/icons-material/Business";
import CallIcon from "@mui/icons-material/Call";
import CakeIcon from "@mui/icons-material/Cake";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { GitHub, LinkedIn } from "@material-ui/icons";

const Identite = () => {
  const [educationFormDialogOpen, setEducationFormDialogOpen] = useState(false);
  const [userInfo, setUserInfo] = useState({});

  const query = useQuery();
  const id_identite = query.get("id_identite");
  const handleCloseEducationForn = () => {
    setEducationFormDialogOpen(false);
  };

  const handleOpenEducationFormDialog = (education) => {
    setEducationFormDialogOpen(true);
  };

  const handleFetchInformation = () => {
    CVService.getDomaineCompetenceList({
      id_identite: id_identite,
    }).then((res) => {
      if (res && res.data) {
        setUserInfo(res.data);
      }
    });
  };

  useEffect(() => {
    handleFetchInformation();
  }, []);
  return (
    <>
      <DomaineCompetenceForm
        open={educationFormDialogOpen}
        onFormClose={handleCloseEducationForn}
      />
      <Paper>
        <Grid item xs={12} width={"100%"}>
          <CardHeader
            sx={{ m: 2 }}
            title="Identités"
            action={
              <Grid>
                <AppButton
                  icon={<AddCircleOutlineOutlinedIcon />}
                  text={"Ajouter"}
                  onClick={handleOpenEducationFormDialog}
                  variant={"outlined"}
                />
              </Grid>
            }
          />
          <Grid
            container
            display={"flex"}
            m={3}
            alignItems={"center"}
            flexDirection={"row"}
          >
            <Grid>
              <Avatar
                sx={{
                  m: 1,
                  width: "clamp(100px, 15vw, 150px)",
                  height: "clamp(100px, 15vw, 150px)",
                  fontSize: "clamp(40px, 8vw, 80px)",
                }}
                alt={showFullName(userInfo.nom, userInfo.prenoms)}
                src={userInfo.photo_link}
              />
            </Grid>
            <Grid flexGrow={1}>
              <CardHeader
                subheader={
                  <Grid>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <WorkOutlineIcon />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {`${userInfo.fonction || NA()}`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <BusinessIcon />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {`${userInfo.adresse || NA()}`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <CakeIcon />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                        }}
                      >
                        {`${userInfo.annee_naissance ? new Date().getFullYear() - userInfo.annee_naissance : "NA"} ans`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <CallIcon />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {` ${userInfo.telephone1 || NA()} / ${userInfo.telephone2 || ""}`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <EmailOutlinedIcon />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {`${userInfo.email || NA()}`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <LinkedIn />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {`${userInfo.linkedin || NA()}`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <GitHub />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {`${userInfo.github || NA()}`}
                      </Typography>
                    </Stack>
                  </Grid>
                }
                component="div"
                title={
                  <Grid item xs={8}>
                    <Typography
                      property="name"
                      sx={{
                        fontSize: {
                          xs: "1.1rem",
                          sm: "1.3rem",
                          md: "1.6rem",
                        },
                        fontWeight: 600,
                        wordBreak: "break-word",
                      }}
                    >
                      {showFullName(userInfo.nom, userInfo.prenoms)}
                    </Typography>
                  </Grid>
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default Identite;
